import React, { useState } from 'react'
import { PolicyDetail } from './details'
import { PolicyPayment } from './payment'

const PolicyDetails = () => {
  const [screen, setScreen] = useState<string>('default')
  const [amount, setAmount] = useState<number | undefined>(0)

  switch (screen) {
    case 'default': {
      return <PolicyDetail setScreen={setScreen} setAmount={setAmount} />
    }
    case 'payment': {
      return <PolicyPayment amount={amount} setScreen={setScreen} />
    }
    default:
      return <PolicyDetail setScreen={setScreen} setAmount={setAmount} />
  }
}

export { PolicyDetails }
